import { isEmpty, has } from 'lodash'

export const useBuildQueryParams = (
  filters: Record<string, unknown> = {},
): Record<string, unknown> => {
  return Object.entries(filters).reduce((acc: Record<string, unknown>, [key, value]) => {
    if (typeof value === 'number') {
      acc[key] = value
    } else if (!isEmpty(value)) {
      if (typeof value === 'object') {
        if (Array.isArray(value)) acc[key] = value.map(({ value }) => value)
        else if (value !== null && Object.hasOwn(value, 'value'))
          acc[key] = (value as Record<string, unknown>).value
      } else {
        acc[key] = value
      }
    }
    return acc
  }, {})
}
